<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>We will be exhibiting at Beautyworld Japan Fukuoka 2026.</h3>
      <br>

      <div class="news_image">
        <img src="/assets/img/bwf09_outline_cube_L_jp.jpg" alt="ビューティーワールドジャパン2026福岡">
      </div>

      <p>
  You will be able to experience our professional-use machine Dr-PRO MAX, which was released just last year,
  as well as our retail beauty device Dr-PRO BEAUTY SECRET.<br>
  We look forward to welcoming you—please feel free to stop by.
      </p>

      <p>
    Dates: February 16 (Mon) – 18 (Wed), 2026<br>
  Hours: 10:00–17:00 (until 16:30 on the final day)<br>
  Venue: Marine Messe Fukuoka, Hall A<br>
  (7-1 Okihama-machi, Hakata-ku, Fukuoka, Fukuoka 812-0031, Japan)<br>
  Exhibitor: Scandinavia Service Co., Ltd.<br>
  Booth No.: E-017<br>
      </p>

      <p class="reserve">
        Advance reservations:
        <a
          href="https://docs.google.com/forms/d/1dg8De4t5Kx0dz0NrIhrr86d1DWfuaMqzD5DYpWbixxo/edit"
          target="_blank"
          rel="noopener"
        >
          Reservation Form
        </a>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news20260216',
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

.news_image {
  margin: 10px 0 25px;
}

.news_image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.reserve a {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>

